// NOTE
// Please use your own firebase details below. For more details visit: https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/documentation/development/firebaseIntegration.html


import firebase from 'firebase/app'

// Initialize Firebase
const config = {
  apiKey: "AIzaSyCINFExHucyUpLBh7RLfGJtNbAY5RpOLng",
  authDomain: "e-office-jbm-2021.firebaseapp.com",
  projectId: "e-office-jbm-2021",
  storageBucket: "e-office-jbm-2021.appspot.com",
  messagingSenderId: "773383128077",
  appId: "1:773383128077:web:eea7438294d0f8e8124144",
  measurementId: "G-HPBBCYVKV8"
}

firebase.initializeApp(config);
